import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import {
  CollectionManageAccessModalService,
  WorkspaceAccessSelectorComponent,
} from '@mode/collections/feature-manage-access';

export const DowngradedCollectionsFeatureManageAccessModule = angular
  .module('downgraded-collections-feature-manage-access', [])
  .directive('modeWorkspaceAccessSelector', downgradeComponent({ component: WorkspaceAccessSelectorComponent }))
  .service('CollectionManageAccessModalService', downgradeInjectable(CollectionManageAccessModalService)).name;
